import { AudioManager } from "../AudioManager";
import { Runtime } from "../Runtime";
import { SaveLoadManager } from "../saveload/SaveLoadManager";

class _AdHelper {
    #rewardedAdReady: boolean;
    #soundAlreadyMuted: boolean;

    get IsRewardedAdReady() {
        return this.#rewardedAdReady;
    }
    #callback: ((success: boolean) => void) | null;
    #context: any;

    init() {
        this.#callback = null;
        this.#context = null;

        window.GD_OPTIONS = {
            gameId: "c01a7e40762d4f0f9aef1be852a487df",
            onEvent: (event: { name: string }) => {
                switch (event.name) {
                    case "SDK_GAME_START":
                        this._callCallback(true);
                        this.resumeAndUnmuteGame();
                        break;
                    case "SDK_GAME_PAUSE":
                        this.pauseAndMuteGame();
                        break;
                    case "SDK_REWARDED_WATCH_COMPLETE":
                        this._callCallback(true);
                        this.resumeAndUnmuteGame();
                        break;
                    case "AD_ERROR":
                        this._callCallback(false);
                        this.resumeAndUnmuteGame();
                        break;
                }
            },
        };

        // Load the Game Distribution SDK script
        (function (d: Document, s: string, id: string) {
            let js: any, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://html5.api.gamedistribution.com/main.min.js';
            fjs.parentNode?.insertBefore(js, fjs);
        }(document, 'script', 'gamedistribution-jssdk'));

        setTimeout(() => {
            this.loadRewardedAd();
        }, 1000);
    }
    showAd(callback: (success: boolean) => void, context: any) {
        this.#callback = callback;
        this.#context = context;
        if (typeof window.gdsdk !== 'undefined' && window.gdsdk.showAd !== 'undefined') {
            window.gdsdk.showAd();
        }
    }
    loadRewardedAd() {
        if (window.gdsdk !== 'undefined' && window.gdsdk.preloadAd !== 'undefined') {
            window.gdsdk.preloadAd('rewarded')
                .then((_: any) => {
                    this.#rewardedAdReady = true;
                })
                .catch((_: any) => {
                    this.#rewardedAdReady = false;
                });
        }
    }
    showRewardedAd(callback: (success: boolean) => void, context: any) {
        this.#callback = callback;
        this.#context = context;
        if (window.gdsdk !== 'undefined' && window.gdsdk.showAd !== 'undefined') {
            window.gdsdk.showAd('rewarded')
                .then((_: any) => { })
                .catch((_: any) => { });
        }
    }
    error() {
        this._callCallback(false);
    }
    pauseAndMuteGame() {
        Runtime.pauseGamespeed();
        this.#soundAlreadyMuted = SaveLoadManager.GameData.muted;
        AudioManager.mute();
    }
    resumeAndUnmuteGame() {
        Runtime.unpauseGamespeed();
        if (!this.#soundAlreadyMuted) {
            AudioManager.unmute();
        }
    }

    private _callCallback(success: boolean) {
        if (this.#callback != null) {
            this.#callback(success);
            this.#callback = null;
        }
    }
}

export const AdHelper = new _AdHelper();
